<fieldset>
  <legend>
    {{ 'common.phonebooks' | translate}}
  </legend>
  <div class="alert alert-primary">
    {{ 'messages.deleteFromPhonebooks' | translate }}
  </div>
  <!-- phonebookIds -->
  <div class="row">
    <phonebook-selection-list [values]="phonebookIds" [type]="'phonebooksListForServices'" [form]="form" controlName="phonebookIds"
      searchLabel="common.search"
      (values)="emitPhonebookIds($event)"
      [isSmallSize]="true">
    </phonebook-selection-list>
  </div>
</fieldset>
